import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import loadScript from "vue-plugin-load-script";

import subtitle from "./components/SubTitle";
import header from "./components/Header";
import footer from "./components/Footer";
import google from "./components/GoogleSignin";
import menu from "./components/Menu";

import "@/style/global.parts.css";

Vue.config.productionTip = false;

Vue.component("Header", header);
Vue.component("Footer", footer);
Vue.component("Google", google);
Vue.component("Menu", menu);
Vue.component("SubTitle", subtitle);

Vue.use(loadScript);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
